// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerRoot.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import ReportDesigner from './Izenda.ReportDesigner';
import ReportDesignerStore from 'logic/Izenda.ReportDesignerStore';
import MenuStore from 'logic/Izenda.ReportDesignerMenuStore';
import connect from 'share/enhancers/Izenda.Connect';
import AuthorizationConstants from 'logic/data/Izenda.AuthorizationConstants';
import LicenseCheckerConstants from 'logic/data/Izenda.LicenseCheckerConstants';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import uiState from 'logic/Izenda.UiState';
import Config from 'Izenda.Config';
import { isNil, get, uniqueId } from 'lodash/fp';
import QueryStringUtil from 'share/utils/Izenda.QueryStringUtil';
import { SOURCE_PATH_QUERY_KEY } from 'logic/data/Izenda.RouteConstants';

@connect({ licenseKey: LicenseCheckerConstants.LICENSE_KEY.ReportDesigner })
class ReportDesignerRoot extends Component {
  constructor(props) {
    super(props);
    this.checkPermissions(props);
    this.loadInitial(props);
  }

  componentWillReceiveProps(nextProps) {
    const isLocationChanged =
      !get('location.state.keepState', nextProps) &&
      nextProps.location.key !== this.props.location.key;
    this.checkPermissions(nextProps);
    if (isLocationChanged) {
      this.loadInitial(nextProps, true);
    }
  }
  
  /**
   * Check permission for report designer page
   * @param {object} props 
   */
  checkPermissions(props: any) {
    const { authorization, router, params: { reportId } } = props;
    const hasAddNewPrivileges = authorization.checkPrivileges([
      AuthorizationConstants.PERMISSION_KEY.ReportsCanCreateNewReportValue
    ]);
    const hasOverwritePrivilege = authorization.checkPrivileges([
      AuthorizationConstants.PERMISSION_KEY
        .ReportsActionsOverwriteExistingReport
    ]);

    if (
      (isNil(reportId) && !hasAddNewPrivileges) ||
      (!isNil(reportId) && !hasOverwritePrivilege)
    ) {
      router.push(routeUtils.getNoPermissionUrl());
    }
  }
  /**
   * Init state for report designer page
   * @param {object} props 
   * @param {boolean} isReload Indicate whether user cancel the change and the report designer is reload
   */
  loadInitial(props: any, isReload: boolean) {
    // License is expired, navigate to Settings pages
    if (uiState.expiredLicense) {
      const settingLink = routeUtils.getSettingsUrl();
      props.router.push(settingLink);
    }

    const { params: { reportId }, location } = props;
    this.key = uniqueId('ReportDesignerLocationID_');

    this.store = new ReportDesignerStore(false, reportId, null, isReload);
    this.store.updateReportListURI(QueryStringUtil.getValueByKey(get('query', location), SOURCE_PATH_QUERY_KEY));
    this.menuStore = new MenuStore(reportId);
  }

  componentWillUnmount() {
    this.store.destroy();
  }

  render() {
    var isNewDefault = isNil(this.props.params.reportId);
    return (
      !uiState.expiredLicense && (
        <ReportDesigner
          key={this.key}
          store={this.store}
          menuStore={this.menuStore}
          isNewDefault={isNewDefault}
          {...this.props}
        />
      )
    );
  }
}

export {
  ReportDesigner as Component,
  ReportDesignerStore as Store,
  ReportDesignerRoot as Container
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Izenda.ReportDesignerRoot.js